// Fetches ephemeral TURN credentials from the API worker.
// Falls back to public Cloudflare STUN if TURN isn't configured yet.

import { API_BASE, authHeaders } from "./config";

const FALLBACK: RTCIceServer[] = [{ urls: "stun:stun.cloudflare.com:3478" }];

export async function fetchIceServers(): Promise<RTCIceServer[]> {
  try {
    const resp = await fetch(`${API_BASE}/api/turn-credentials`, {
      headers: authHeaders(),
    });
    if (!resp.ok) {
      console.warn(`[ice] credentials fetch returned ${resp.status} — using STUN fallback`);
      return FALLBACK;
    }
    const data = (await resp.json()) as { iceServers?: RTCIceServer[] };
    if (Array.isArray(data.iceServers) && data.iceServers.length > 0) {
      return data.iceServers;
    }
    return FALLBACK;
  } catch (err) {
    console.warn("[ice] credentials fetch failed", err);
    return FALLBACK;
  }
}
